import React from 'react'
import {StyledActions} from './styled/Actions.styled'

const Actions = ({children}) => {
  return <StyledActions>{children}</StyledActions>
}

export default Actions
